<!-- NumberLine.vue -->
<template>
  <div class="number-line tw-flex tw-relative">
    <div
      class="tw-flex tw-w-full tw-rounded-full tw-overflow-hidden tw-py-2 tw-px-3 tw-border tw-border-solid tw-border-inherit"
      :style="{
        backgroundImage
      }"
    >
      <NumberLineSection
        v-for="(section, i) in sections"
        :key="section.label"
        :is-last="i === sections.length - 1"
        :label="section.label"
        :color="section.color"
        :width="section.width"
        :min="min"
        :max="max"
        :background-image="backgroundImage"
      />
    </div>

    <NumberLineMarker
      v-for="marker in combinedMarkers"
      :key="marker.label"
      :label="marker.label"
      :max-length="maxMarkerLength"
      :color="marker.color"
      :value="marker.value"
      :position="marker.position"
      :show-value="marker.showValue"
      :shift="marker.shift"
      :min="min"
      :max="max"
      @markerClick="onMarkerClick"
    />
  </div>
</template>


<script>
import NumberLineSection from './NumberLineSection.vue';
import NumberLineMarker from './NumberLineMarker.vue';

export default {
  name: 'NumberLine',
  components: {
    NumberLineSection, NumberLineMarker,
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    sections: {
      type: Array,
      required: true,
    },
    markers: {
      type: Array,
      required: true,
    },
    maxMarkerLength: {
      type: Number,
      default: 25,
    },
    gradient: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    // Creates a new property
    // Updates when any dependent property changes
    cleanGradient() {
      if (!this.gradient) return null;
      const colors = this.gradient.split(',').map(color => color.trim());

      colors.forEach(color => {
        const isNamed = /^[a-z]+$/.test(color);
        const isHex = /^#[a-f0-9]{6}$/i.test(color);
        if (!isNamed && !isHex) throw new Error(`Invalid color (${color}) provided for number line gradient`);
      });
      return colors.join(',');
    },
    backgroundImage() {
      if (!this.cleanGradient) return null;
      return `linear-gradient(to right, ${this.cleanGradient})`;
    },
    orderedMarkers() {
      return this.markers.slice().sort((a, b) => a.value - b.value);
    },
    evenMarkers() {
      const evens = this.orderedMarkers.filter((_, i) => i % 2 === 0);
      return evens.map(marker => {
        return {
          ...marker,
          position: 'top',
        };
      });
    },
    oddMarkers() {
      const odds = this.orderedMarkers.filter((_, i) => i % 2 !== 0);
      return odds.map(marker => {
        return {
          ...marker,
          position: 'bottom',
        };
      });
    },
    combinedMarkers() {
      return this.evenMarkers.concat(this.oddMarkers);
    },
  },
  watch: {
    // Watches an existing property
    // Only runs when the watched property changes
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    onMarkerClick(marker) {
      this.$emit('markerClick', marker);
    },
  },
};
</script>


<style scoped>

</style>
